<script setup>
import MembersInfoContent from '@/@core/components/MembersInfoContent.vue'

const props = defineProps({
  isDialogVisible: {
    type: Boolean,
    default: false
  },
  initialTab: {
    type: String,
    default: 'how-rm-works'
  }
})

const emit = defineEmits(['update:isDialogVisible'])

const closeDialog = () => {
  emit('update:isDialogVisible', false)
}
</script>

<template>
  <VDialog
    :model-value="isDialogVisible"
    max-width="500"
    scrollable
    @update:model-value="$emit('update:isDialogVisible', $event)"
  >
    <VCard>
      <VCardTitle class="d-flex justify-space-between align-center pa-4 pb-2">
        <span class="title-text">
          <strong>Members:</strong> <span class="title-text-normal">Artists, Athletes, CEOs, Investors, Restaurateurs</span>
        </span>
        <VBtn
          icon
          variant="text"
          size="small"
          @click="closeDialog"
        >
          <VIcon>mdi-close</VIcon>
        </VBtn>
      </VCardTitle>

      <VCardText class="pa-0">
        <MembersInfoContent :initial-tab="props.initialTab" />
      </VCardText>
    </VCard>
  </VDialog>
</template>

<style lang="scss" scoped>
.title-text {
  font-size: 0.9rem;
  font-weight: 900;
  margin: 0;
  color: var(--ds-text-strong);
}

.title-text strong {
  font-weight: 900;
}

.title-text-normal {
  text-wrap: auto;
  font-weight: 400;
}
</style>
